/** 与 playwright-service `preview-url.ts` 的 PREVIEW_REMOTE_*_STORAGE_KEY 对齐。写入由外部 Playwright init script 负责。 */
export const GOGO_REMOTE_WS_URL_STORAGE_KEY = 'wujiGogo:remote:wsUrl';
export const GOGO_REMOTE_BROWSER_ID_STORAGE_KEY = 'wujiGogo:remote:browserId';
function readStorage(key) {
    try {
        return sessionStorage.getItem(key) || '';
    }
    catch {
        return '';
    }
}
/** 读取 remote 预览桥的 wsUrl / browserId：优先 URL query，否则 sessionStorage（Playwright 写入）。 */
export function readGogoRemotePreviewConnection() {
    const search = new URLSearchParams(window.location.search);
    return {
        wsUrl: search.get('wsUrl') || readStorage(GOGO_REMOTE_WS_URL_STORAGE_KEY),
        browserId: search.get('browserId') || readStorage(GOGO_REMOTE_BROWSER_ID_STORAGE_KEY),
    };
}
